import { Trade } from "emrn-hybrid/Trade";
import React, { PureComponent } from "react";
import { Dialog } from "emrn-design/Dialog";
import { Text, StyleSheet } from "react-native";
import { Loading } from "emrn-design/Loading";
import { EmTouchableOpacity } from "emrn-design/EmTouchable";

import { rsaEncrypt, desEncrypt, rsaDecrypt } from "../util";

import { webLogin } from "./webLogin";

interface SubmitProps {
  minutes: number;
  userId?: string;
  password?: string;
  serverAddress?: string;
  onSuccess: (response: Trade.AccountInfo) => void;
}

interface SubmitState {
  submiting?: boolean;
}

export class Submit extends PureComponent<SubmitProps, SubmitState> {
  private dialog = React.createRef<Dialog>();
  private loading = React.createRef<Loading>();

  constructor(props: SubmitProps) {
    super(props);
    this.state = {};
  }

  private showMessage = (message: string) => {
    this.dialog.current?.show(message);
  };

  private handleLogin = () => {
    if (this.state.submiting) {
      return;
    }

    const { userId, minutes = 30, password, serverAddress } = this.props;

    if (!userId) {
      this.showMessage("请输入资金账号");
      return;
    }

    if (!password) {
      this.showMessage("请输入交易密码");
      return;
    }

    if (!serverAddress) {
      this.showMessage("中台网关地址未配置");
      return;
    }

    if (!/^\d{11}$/.test(userId) && !/^\d{6}$/.test(password)) {
      this.showMessage("您输入的信息有误，请重新输入");
      return;
    }

    this.setState({ submiting: true });

    const loading = this.loading.current?.show("正在登录");
    webLogin({
      User_id_lx: "Z",
      User_id: userId,
      Jymm: rsaEncrypt(password),
      Yybdm: userId.substring(0, 4),
      Cssj: (minutes * 60).toString(),
    })
      .then((result) => {
        const { Data, Status, Message } = result;
        if (Status == 0 && Data && Data.length > 0) {
          const sessionId = rsaDecrypt(Data[0].Syspm3);
          this.props.onSuccess(buildAccountInfo(userId, sessionId));
        } else {
          this.showMessage(Message || "您输入的信息有误，请重新输入");
        }
      })
      .catch((error: any) => {
        this.showMessage(error?.message);
      })
      .finally(() => {
        loading?.destroy();
        this.setState({ submiting: false });
      });
  };

  render() {
    const { submiting } = this.state;
    return (
      <>
        <EmTouchableOpacity
          activeOpacity={0.9}
          onPress={this.handleLogin}
          style={[styles.container, submiting && styles.disabled]}
        >
          <Text style={styles.text}>登录</Text>
        </EmTouchableOpacity>
        <Dialog ref={this.dialog} />
        <Loading ref={this.loading} />
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: 50,
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#3381e3",
  },
  disabled: {
    backgroundColor: "rgba(51,129,227,0.5)",
  },
  text: {
    color: "#fff",
    fontSize: 16,
    letterSpacing: 0.3,
    fontWeight: "500",
  },
});

function buildAccountInfo(userId: string, session: string) {
  return {
    androidOsv: "ios_101",
    appKey: "dfcft",
    appVersionName: "10.11",
    branchCode: userId.substring(0, 4),
    customerId: "",
    decryptCustomerId: userId,
    decryptKhCustomerId: userId,
    decryptUserId: userId,
    deviceImei: "5F1C95EB-DB14-44F0-9967-9BE7C01848F5",
    deviceImsi: "",
    deviceMacAddress: "",
    deviceName: "emrnweb-browser",
    deviceType: "iPhone8,1",
    isLogin: true,
    isLoginTimeout: false,
    khCustomerId: "",
    mobilePhone: "",
    siaRelationInfo: [],
    token: session,
    tradeCurrentUsePhone: "",
    tradeHardInfo:
      "5F1C95EB-DB14-44F0-9967-9BE7C01848F5;IMSI:NA;MAC:NA;ICCID:NA;UMPN:Gi5EuMOut2YuuKTJRxenzw==",
    tradeHardInfoH5: "",
    tradeOsV: "ios_101",
    udidWithBundle: "5F1C95EB-DB14-44F0-9967-9BE7C01848F5iphone",
    unloginSession: "",
    unloginToken: "",
    userId: desEncrypt(userId),
    username: userId,
    uuid: "5F1C95EB-DB14-44F0-9967-9BE7C01848F5",
  };
}
